import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from '../../common/loadingComponent';
import { REGISTRY } from '../../../store/ceeSearchStore';
import { layoutActions } from '../../../store/layoutStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { apiGet, getHostApi, getHostUrl } from '../../../store/apiWrapper';
import Paging from '../../common/pagingComponent';
import NoDataComponent from '../../common/noDataComponent';
import ResponsiveTable from "../../layoutItems/responsiveTable";
import RefreshComponent from '../../layoutItems/refreshComponent';
import { upperCase } from 'lodash';

const AML_REQUEST_TYPE = {
    person: "Person",
    company: "Company",
    foreign: "Foreign",
    bulk: "Bulk",
    path: "Path"
};

const STATUS = {
    unprocessed: "Unprocessed",
    processed: "Processed",
    read: "Read",
    error: "Error",
    obligation: "MonetaryObligation",
    obliAdded: "MonetaryObligationAdded",
    delayed: "Delayed",
};

const MIN_PAGESIZE = 50;

class CeeResultsAll extends React.Component {
    constructor(props) {
        super(props);
        let country = (this.props.registry === REGISTRY.cee ? "CZ" : "SK");
        this.state = {
            country: country,
            pageSize: MIN_PAGESIZE,
            index: 1,
            data: null,
            totalCount: null,
            autoRefresh: false,
            isLoading: false,
            isRefreshing: false,
            manualOverride: false,
        };
    }
    timer = null;

    render() {
        if (this.state.isLoading)
            return <Circles />;
        else
            return !isNullOrUndefined(this.state.data) && this.state.data.length > 0 ? this.renderTable() : <NoDataComponent style={{ height: "100%" }} />
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    renderTable() {
        const { registry } = this.props;
        return (
            <>
                <div style={{ display: "flex" }}>
                    {!isNullOrUndefined(this.state.data) && this.state.data.length > 0 && <RefreshComponent
                        style={{ margin: "1em 0", flex: "1 0 auto" }}
                        autoRefresh={this.state.autoRefresh}
                        onAutoRefresh={() => this.onAutoRefresh(!this.state.autoRefresh)}
                        onRefresh={() => this.getData()}
                    />}
                    <div style={{ margin: "auto", display: "flex" }}>
                        <Paging selectedPage={this.state.index}
                            totalPages={Math.ceil(this.state.totalCount / this.state.pageSize)}
                            setPage={this.onPageClick}
                            alwaysShow={Math.ceil(this.state.totalCount / MIN_PAGESIZE) > 1}
                        />
                        {Math.ceil(this.state.totalCount / MIN_PAGESIZE) > 1 && <>
                            <label style={{ fontSize: ".9em", margin: "auto", padding: "0em .7em" }}>
                                {ReactHtmlParser(this.props.translate('Search.PageSize'))}
                            </label>
                            <input type="number"
                                className="results-pagesize-input"
                                autoComplete="off"
                                onChange={(e) => this.onPageSizeChange(e.target.value)}
                                value={this.state.pageSize}
                                style={{ width: "5em", borderRadius: "1em", textAlign: "center" }}
                            />
                        </>}
                    </div>
                    {!isNullOrUndefined(this.state.data) && this.state.data.length > 0 && <RefreshComponent
                        style={{ visibility: "hidden", flex: "1 0 auto" }}
                        autoRefresh={this.state.autoRefresh}
                        onAutoRefresh={() => this.onAutoRefresh(!this.state.autoRefresh)}
                        onRefresh={() => this.getData()}
                    />}
                </div>
                <div className="search-progress searching" style={{ visibility: this.state.isRefreshing ? "visible" : "hidden" }} />
                <div className="card">
                    <div className="card-body card-body-fill">
                        {!this.state.isLoading && !isNullOrUndefined(this.state.data) && this.state.data.length > 0 && <ResponsiveTable>
                            <table className="table table-report-section table-marketing-list">
                                <thead>
                                    <tr>
                                        <th><Translate id="Search.Common.Request" /></th>
                                        <th><Translate id="Search.Cee.DateRequested" /></th>
                                        <th><Translate id="Search.Cee.Status" /></th>
                                        <th><Translate id="Search.Cee.DateProcessed" /></th>
                                        {(registry === REGISTRY.cre || registry === REGISTRY.rpve) && <th><Translate id="Report.Common.Source" /></th>}
                                        {registry !== REGISTRY.aml && <th><Translate id="SearchResult.ResultsCount" /></th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {(registry === REGISTRY.cee || registry === REGISTRY.cre || registry === REGISTRY.rpve) && this.state.data.map((req) => this.getCeeRow(req, this.props.match.url, registry))}
                                    {registry === REGISTRY.aml && this.state.data.map((req) => this.getAmlRow(req, this.props.match.url))}
                                </tbody>
                            </table>
                        </ResponsiveTable>}
                    </div>
                </div>
                <div className="paging-wrapper">
                    <Paging justify="center"
                        selectedPage={this.state.index}
                        totalPages={Math.ceil(this.state.totalCount / this.state.pageSize)}
                        setPage={this.onPageClick}
                        alwaysShow={Math.ceil(this.state.totalCount / MIN_PAGESIZE) > 1}
                    />
                </div>
            </>
        );
    }

    onPageSizeChange = (value) => {
        let parsed = parseInt(value);
        if (isNullOrUndefined(parsed) || isNaN(parsed) || parsed < MIN_PAGESIZE)
            parsed = MIN_PAGESIZE;
        this.setState({ pageSize: parsed }, () => { this.getData() })
    }

    onPageClick = (page) => {
        this.setState({ index: page }, () => { this.getData() })
    }

    onAutoRefresh(value) {
        this.setState({ autoRefresh: value, manualOverride: true });
        if (value)
            this.setTimer(5000);
    }

    getData = () => {
        // Previous request has not yet finished, try later
        if (this.state.isLoading === true || this.state.isRefreshing === true) {
            this.setTimer(1000);
            return;
        }

        if (isNullOrUndefined(this.state.data))
            this.setState({ isLoading: true });
        else
            this.setState({ isRefreshing: true });

        if (this.props.registry === REGISTRY.cee || this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) {
            apiGet(`${getHostApi()}/api/search/cee/requests`,
                { country: this.state.country, pageSize: this.state.pageSize, index: this.state.index - 1 },
                (data) => this.success(data.data),
                () => this.onError(),
                () => this.setState({ isLoading: false, isRefreshing: false })
            );
        }
        else {
            apiGet(`${getHostApi()}/api/search/aml/requests`, null,
                (data) => this.success(data.data),
                () => this.onError(),
                () => this.setState({ isLoading: false, isRefreshing: false })
            );
        }
    }

    onError = () => {
        this.setState({ isLoading: false, isRefreshing: false });
        if (this.state.manualOverride && this.state.autoRefresh)
            this.setTimer(5000);
    }

    success = (data) => {
        this.setState({ isLoading: false, isRefreshing: false });
        //there are unprocessed data and user hasnt overriden the control or user has overriden and set to true
        let unprocessed = this.props.registry === REGISTRY.aml ? this.amlHasUnprocessed(data.resultList) : this.ceeHasUnprocessed(data.resultList);
        if ((unprocessed && !this.state.manualOverride) || this.state.manualOverride && this.state.autoRefresh) {
            this.setState({ autoRefresh: true, data: data.resultList, totalCount: data.totalCount });
            this.setTimer(5000);
        }
        else
            this.setState({ autoRefresh: false, data: data.resultList, totalCount: data.totalCount });
    }

    setTimer = (ms) => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getData, ms);
    }

    ceeHasUnprocessed = (data) => {
        let parents = false;
        let children = false;
        if (data.filter(x => x.status === STATUS.unprocessed || x.status === STATUS.delayed).length > 0)
            parents = true;

        data.map(x => {
            if (x.children.length > 0) {
                if (x.children.filter(x => x.status === STATUS.unprocessed || x.status === STATUS.delayed).length > 0)
                    children = true;
            }
        });
        return parents || children;
    }

    amlHasUnprocessed = (data) => {
        return data.filter(x => x.status === STATUS.unprocessed || x.status === STATUS.delayed).length > 0
    }

    getAmlRow = (aml, url) => {
        return (
            <tr key={aml.id} className='colorize' onClick={() => this.getAmlLink(aml, url, true)} style={{ cursor: this.getAmlLink(aml, url, false) === true ? "pointer" : "" }}>
                <td data-label={this.props.translate('Search.Common.Request')}>
                    {aml.requestType === AML_REQUEST_TYPE.company && <NavLink
                        className={aml.status === STATUS.unprocessed || aml.status === STATUS.error || aml.status === STATUS.delayed || !aml.completed ? 'disabled' : ''}
                        to={`${url}/company/${aml.id}`}
                    >
                        <span>{aml.companyId} {aml.companyName && <span style={{ fontWeight: "400" }}>({aml.companyName})</span>}</span>
                    </NavLink>}
                    {aml.requestType === AML_REQUEST_TYPE.path && <NavLink
                        className={aml.status === STATUS.unprocessed || aml.status === STATUS.error || aml.status === STATUS.delayed || !aml.completed ? 'disabled' : ''}
                        to={`${url}/path/${aml.id}`}
                    >
                        <span>{this.props.translate("Charts.GraphTree") + ' ' + aml.companyId} {aml.companyName && <span style={{ fontWeight: "400" }}>({aml.companyName})</span>}</span>
                    </NavLink>}
                    {aml.requestType === AML_REQUEST_TYPE.foreign && <NavLink
                        className={aml.status === STATUS.unprocessed || aml.status === STATUS.error || aml.status === STATUS.delayed || !aml.completed ? 'disabled' : ''}
                        to={`${url}/person/${aml.id}`}
                    >
                        <span>{aml.companyName}</span>
                    </NavLink>}
                    {aml.requestType === AML_REQUEST_TYPE.person && <NavLink
                        className={aml.status === STATUS.unprocessed || aml.status === STATUS.error || aml.status === STATUS.delayed || !aml.completed ? 'disabled' : ''}
                        to={`${url}/person/${aml.id}`}
                    >
                        <>{aml.firstName}{!isNullOrUndefined(aml.middleName) && ' '+aml.middleName } {aml.lastName}  {aml.birthDate !== null && <span>({aml.birthDateFormated})</span>}  {!isNullOrUndefined(aml.birthYear) && <span>({aml.birthYear})</span>}</>
                    </NavLink>}
                    {aml.requestType === AML_REQUEST_TYPE.bulk && <>
                        <a id={`bulk${aml.id}`}
                            href={this.getAmlBulkUrl(aml.id, aml.status, aml.completed)}
                            target="_blank"
                            style={{ display: "inline-block" }}
                            className={(aml.status === STATUS.unprocessed || aml.status === STATUS.error || aml.status === STATUS.delayed || aml.status === STATUS.obligation || !aml.completed) ? 'disabled' : ''}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Translate id="Search.Common.Bulk" />
                        </a>
                        <span> ({aml.bulkCount}  <Translate id={aml.bulkCount === 1 ? "Aml.Bulk.Request" : (aml.bulkCount > 1 && aml.bulkCount < 5) ? "Aml.Bulk.Requests" : "Aml.Bulk.Requests5"} />)</span>
                    </>}
                </td>
                <td data-label={this.props.translate('Search.Cee.DateRequested')}>{aml.insertedFormated}</td>
                <td data-label={this.props.translate('Search.Cee.Status')}><span>{this.getCeeStatus({ ...aml, isBulk: aml.requestType === AML_REQUEST_TYPE.bulk })}</span></td>
                <td data-label={this.props.translate('Search.Cee.DateProcessed')}>{aml.completedFormated}</td>
            </tr>
        );
    }

    getAmlLink = (aml, url, push = true) => {
        if (aml.requestType === AML_REQUEST_TYPE.company && aml.status !== STATUS.unprocessed && aml.status !== STATUS.error && aml.status !== STATUS.delayed && aml.completed) {
            return push ? this.props.history.push(`${url}/company/${aml.id}`) : true;
        }
        if (aml.requestType === AML_REQUEST_TYPE.person && aml.status !== STATUS.unprocessed && aml.status !== STATUS.error && aml.status !== STATUS.delayed && aml.completed) {
            return push ? this.props.history.push(`${url}/person/${aml.id}`) : true;
        }
        if (aml.requestType === AML_REQUEST_TYPE.bulk && aml.status !== STATUS.unprocessed && aml.status !== STATUS.error && aml.status !== STATUS.delayed && aml.status !== STATUS.obligation && aml.completed) {
            return push ? window.open(this.getAmlBulkUrl(aml.id, aml.status, aml.completed), "_blank") : true;
        }
        return false;
    }

    getCeeRow = (cee, url, registry, isDetail = false) => {
        // change url for rpve requests
        url = cee.source === "RPVE" ? url.replace("cre", "rpve") : cee.source === "CRE" ? url.replace("rpve", "cre") : url;

        return (
            <React.Fragment key={cee.id}>
                <tr key={cee.id} className={classnames('colorize', { 'cee-detail-row': isDetail })} onClick={() => this.getCeeLink(cee, url, registry, isDetail, true)} style={{ cursor: this.getCeeLink(cee, url, registry, isDetail, false) === true ? "pointer" : "" }}>
                    <td data-label={this.props.translate("Search.Common.Request")} style={{ paddingLeft: isDetail ? "2.5em" : "", fontWeight: isDetail ? "600" : "700" }} >
                        {!isDetail && !cee.isBulk && <NavLink
                            className={cee.status === STATUS.unprocessed || cee.status === STATUS.error || cee.status === STATUS.delayed || !cee.completed ? 'disabled' : ''}
                            to={`${url}/${cee.id}`}
                            params={{ id: cee.id }}
                        >
                            {cee.type === "Company" ? <span>{!isNullOrUndefined(cee.companyId) ? cee.companyId : ''}{!isNullOrUndefined(cee.companyName) ? (isNullOrUndefined(cee.companyId) ? cee.companyName : <span style={{ fontWeight: "400" }}> ({cee.companyName})</span>) : ''}</span> : cee.displayName}
                        </NavLink>}
                        {isDetail && <NavLink style={{ display: "inline-block" }}
                            className={cee.status === STATUS.unprocessed || cee.status === STATUS.error || cee.status === STATUS.delayed || !cee.completed ? 'disabled' : ''}
                            to={`${url}/cause/${cee.id}`}
                            params={{ id: cee.id }}
                        >
                            Detail: {cee.displayName}
                        </NavLink>}
                        {cee.isBulk && <>
                            <a id={`bulk${cee.id}`}
                                href={this.getBulkUrl(cee.id, cee.status, cee.completed, registry, cee.source)}
                                target="_blank"
                                style={{ display: "inline-block" }}
                                className={(cee.status === STATUS.unprocessed || cee.status === STATUS.error || cee.status === STATUS.delayed || cee.status === STATUS.obligation || !cee.completed) ? 'disabled' : ''}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Translate id="Search.Common.Bulk" />
                            </a>
                            <span>({cee.bulkCount})</span>
                        </>}
                    </td>
                    <td data-label={this.props.translate("Search.Cee.DateRequested")}>
                        {cee.insertedFormated}
                    </td>
                    <td data-label={this.props.translate("Search.Cee.Status")} style={{ fontWeight: cee.status === "Read" ? "400" : "600" }} >
                        {this.getCeeStatus(cee)}
                    </td>
                    <td data-label={this.props.translate("Search.Cee.DateProcessed")}>
                        {cee.completedFormated}
                    </td>
                    {(registry === REGISTRY.cre || registry === REGISTRY.rpve) && <td data-label={this.props.translate("Report.Common.Source")}>{cee.source}</td>}
                    <td data-label={this.props.translate("SearchResult.ResultsCount")}>{cee.resultsCount}</td>
                </tr>
                {cee.children && cee.children.map((child) => this.getCeeRow(child, url, registry, true))}
            </React.Fragment>
        )
    }

    getCeeStatus = (cee) => {
        if (cee.isBulk && cee.status === STATUS.unprocessed && cee.bulkProcessedCount > 0)
            return <Translate id='Search.Cee.Status.Processing' data={{ remaining: cee.bulkCount - cee.bulkProcessedCount, all: cee.bulkCount }} />
        else if (cee.isBulk && cee.status === STATUS.unprocessed && cee.bulkProcessedCount === 0)
            return <Translate id='Search.Cee.Status.Waiting' data={{ before: cee.bulkUnprocessedCount }} />
        else
            return <Translate id={`Search.Cee.Status.${cee.status}`} />
    }

    getCeeLink = (cee, url, registry, isDetail = false, push = true) => {
        url = cee.source == "RPVE" ? url.replace("cre", "rpve") : url;

        if (!isDetail && !cee.isBulk && cee.status !== STATUS.unprocessed && cee.status !== STATUS.error && cee.status !== STATUS.delayed && cee.completed)
            return push ? this.props.history.push(`${url}/${cee.id}`) : true;
        if (isDetail && cee.status !== STATUS.unprocessed && cee.status !== STATUS.error && cee.status !== STATUS.delayed && cee.completed)
            return push ? this.props.history.push(`${url}/cause/${cee.id}`) : true;
        if (cee.isBulk && cee.status !== STATUS.unprocessed && cee.status !== STATUS.error && cee.status !== STATUS.delayed && cee.status !== STATUS.obligation && cee.completed)
            return push ? window.open(this.getBulkUrl(cee.id, cee.status, cee.completed, registry, cee.source), "_blank") : true;
        return false;
    }

    getTagClass = (status) => {
        switch (status) {
            case STATUS.read: return "tag is-success";
            case STATUS.processed: return "tag is-info";
            case STATUS.unprocessed: return "tag is-warning";
            case STATUS.error: return "tag is-danger";
            case STATUS.delayed: return "tag is-warning";
            default: return "tag is-light ";
        }
    }

    getBulkUrl = (id, status, completed, registry, source) => {
        var reg = registry;
        if (registry === REGISTRY.cre || registry === REGISTRY.rpve) {
            if (source === upperCase(REGISTRY.rpve))
                reg = REGISTRY.rpve;
            else if (source === upperCase(REGISTRY.cre))
                reg = REGISTRY.cre;
        }
        if (status === STATUS.unprocessed || status === STATUS.error || status === STATUS.delayed || status === STATUS.obligation || !completed)
            return null;
        return `${getHostUrl()}/files/bulk/result/${reg}/${id}`;
    }

    getAmlBulkUrl = (id, status, completed) => {
        if (status === STATUS.unprocessed || status === STATUS.error || status === STATUS.delayed || status === STATUS.obligation || !completed)
            return null;
        return `${getHostUrl()}/files/bulk/result/aml/${id}`;
    }
}

export default withLocalize(connect(
    null,
    dispatch => bindActionCreators(layoutActions, dispatch)
)(CeeResultsAll));
